// extracted by mini-css-extract-plugin
export default {"container":"coininfo_container__HcErc"};